'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // 
// 
// DEPRECATED
// Use reservationErrors
// 
//

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopupMessageController = function () {
    function PopupMessageController($scope, $timeout) {
        _classCallCheck(this, PopupMessageController);

        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    _createClass(PopupMessageController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.message = "";

            this.time = this.time || 2;

            this.$scope.$on('popup-message', function (e, message) {
                _this.show = true;
                _this.message = message;
                _this.errors = [];
                _this.hidePopupAfter(+_this.time * 1000);
            });

            this.$scope.$on('popup-error', function (e, errors) {
                _this.show = true;
                _this.message = "";
                _this.errors = errors;
                _this.hidePopupAfter(+_this.time * 1000);
            });
        }
    }, {
        key: 'hidePopupAfter',
        value: function hidePopupAfter(time) {
            var _this2 = this;

            if (this.popupTimeout) {
                this.$timeout.cancel(this.popupTimeout);
            }

            this.popupTimeout = this.$timeout(function () {
                return _this2.show = false;
            }, time);
        }
    }]);

    return PopupMessageController;
}();

PopupMessageController.$inject = ['$scope', '$timeout'];

_module3.default.component('popupMessage', {
    template: require('./popupMessage.html'),
    controller: PopupMessageController,
    bindings: {
        // Time to show popup. In ms
        time: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/popupMessage/popupMessage.js
// module id = 502
// module chunks = 2